import React from 'react';
import Text from '../../shared/Text';
import WarningIcon from './logo-icon/WarningIcon';
import { CenteredErrorMessage, SimpleErrorMessage } from './shared-form-components';

const SsoAuthLoginIncorrect: React.FC = () => {
  const isElectron = navigator.userAgent.indexOf('Electron') >= 0;

  React.useEffect(() => {
    document.title = Text.get('sso_doc_title_error');
  }, []);

  return (
    <div>
      {isElectron ? (
        <CenteredErrorMessage
          icon={WarningIcon}
          errorMessages={['ssoAuthSignIn_incorrect_message1', 'ssoAuthSignIn_incorrect_message2']}
        />
      ) : (
        <SimpleErrorMessage errorMessages={'ssoAuthSignIn_failure_browser'} />
      )}
    </div>
  );
};

export default SsoAuthLoginIncorrect;
